// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getUser = createAsyncThunk('appUser/getUser', async (userId) => {
  const response = await axios.get(`/v1/users/${userId}`)
  return response.data
})

export const appUserSlice = createSlice({
  name: 'employee',
  initialState: {
    data: {},
    isLoading: false
  },
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(getUser.pending, (state) => {
        state.isLoading = true
        state.data = {}
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.data = action.payload
        state.isLoading = false
      })
  }
})

export default appUserSlice.reducer
